/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resend_Invitation_ActionInputs */

const fr_resend_invitation_action = /** @type {(inputs: Resend_Invitation_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renvoyer l'invitation`)
};

/**

* @param {Resend_Invitation_ActionInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const resend_invitation_action = /** @type {((inputs?: Resend_Invitation_ActionInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resend_Invitation_ActionInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_resend_invitation_action(inputs)
});